import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=492c2b9b&"
import script from "./ReportsTable.vue?vue&type=script&lang=js&"
export * from "./ReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492c2b9b')) {
      api.createRecord('492c2b9b', component.options)
    } else {
      api.reload('492c2b9b', component.options)
    }
    module.hot.accept("./ReportsTable.vue?vue&type=template&id=492c2b9b&", function () {
      api.rerender('492c2b9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Users/Widgets/ReportsTable.vue"
export default component.exports